import { render, staticRenderFns } from "./Banner.vue?vue&type=template&id=0b00084c&scoped=true"
import script from "./Banner.vue?vue&type=script&lang=ts"
export * from "./Banner.vue?vue&type=script&lang=ts"
import style0 from "./Banner.vue?vue&type=style&index=0&id=0b00084c&prod&lang=scss"
import style1 from "./Banner.vue?vue&type=style&index=1&id=0b00084c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b00084c",
  null
  
)

export default component.exports